import classNames from "classnames";
import PropTypes from "prop-types";
import styles from "./DocumentItem.module.css";
import { useState } from "react";

import pdfIcon from "./PDF_Icon_Small.svg";

import { ChevronDown } from "react-ikonate";
import Markdown from "../Markdown";
import Select from "ManagementTeam/Shared/Select";

import { useFileDownload } from "ManagementTeam/Shared/hooks/useFileDownload";
import { useEffect } from "react";
import { useDocuments } from "ManagementTeam/DocumentsPage/useDocuments";

/**
 * Item used for summaries and documents.
 *
 * The type of assigned item, either "Diamond”, "WWG”, or "Attorney”.  Left Brown Box (#7F6A45) is Diamond, Left Teal Box (#91B6BB) is WWG, and Left Gray Box (#ADB7C0) is Attorney.
 */
export function DocumentItem({
  title,
  description,
  link,
  type,
  onPublish,
  onEdit,
  onDelete,
  separate,
  reorganize,
  className,
  files,
  readOnly,
  isDraft,
  isHideInfo,
}) {
  const [select, setSelect] = useState("Select");
  const { downloadFile } = useDocuments();

  useEffect(() => {
    // eslint-disable-next-line default-case
    switch (select) {
      case "Edit":
        onEdit();
        setSelect("Select");
        break;
      case "Delete":
        onDelete();
        setSelect("Select");
        break;
    }
  }, [select]);

  return (
    <div className={styles.grid}>
      {reorganize ? (
        <div className={styles.hamburgerContainerContainer}>
          <div className={styles.hamburgerContainer}>
            <div className={styles.hamburgerLine} />
            <div className={styles.hamburgerLine} />
            <div className={styles.hamburgerLine} />
          </div>
        </div>
      ) : (
        <div></div>
      )}

      <div className={classNames(styles.grid2, className)}>
        <div className={styles.leftBoxContainer}>
          <div
            className={classNames(
              styles.leftBox,
              type == "WWG" && styles.wwg,
              type == "Attorney" && styles.attorney
            )}
          />
        </div>

        <div
          className={classNames(
            description === "" ? styles.centeredTitle : styles.textContainer
          )}
        >
          <div className={styles.title}>{title}</div>
          <div className={styles.description}>
            {<Markdown content={description} />}
          </div>
        </div>

        {separate && <div className={styles.verticalLine} />}

        {separate === true
          ? files && files.length > 0
            ? files.map((file, i) => (
                <div
                  key={i}
                  className={styles.pdfContainer}
                  onClick={() => {
                    downloadFile(file.downloadPath);
                  }}
                >
                  <img src={pdfIcon} className={styles.pdfImage} />
                  <a href={"#"} className={styles.pdfText}>
                    {file.name + "." + file.type}
                  </a>
                </div>
              ))
            : null
          : files && files.length > 0
          ? files.map((file, i) => (
              <div key={i} className={styles.pdfContainer}>
                <a
                  href={file.src}
                  className={styles.pdfText}
                  style={{ pointerEvents: file.src ? null : "none" }}
                >
                  <img src={pdfIcon} className={styles.pdfImage} />
                </a>
              </div>
            ))
          : null}
      </div>

      <div
        style={{ visibility: !readOnly ? "visible" : "hidden" }}
        className={styles.selectContainer}
      >
        <Select
          options={["Edit", "Delete"]}
          placeholder={"Options"}
          onChange={setSelect}
        />
      </div>

      {!separate && !reorganize ? null : (
        <div
          style={{ visibility: !readOnly && isDraft ? "visible" : "hidden" }}
          className={styles.buttonContainer}
        >
          <button className={styles.button} onClick={onPublish}>
            Publish
          </button>
        </div>
      )}
    </div>
  );
}

DocumentItem.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  list: PropTypes.arrayOf(PropTypes.string),
  link: PropTypes.string,
  type: PropTypes.string,
  onPublish: PropTypes.func,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
  separate: PropTypes.bool,
  reorganize: PropTypes.bool,
  className: PropTypes.string,
};
